import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import ApplicantCreateModal from "./ApplicantCreateModal";
import {deleteArrayItemByKeyValue, objectFilter} from "../../utils/misc";
import ApplicantUploadModal from "./ApplicantUploadModal";


class ApplicantList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            applicants: null,
            pages: null,
            filters: {},
        };
    }

    async componentDidMount() {
        await this.retrieveApplicants();
        await this.retrieveFilterFields();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveApplicants();
        }
    }

    async retrieveFilterFields(){
        const url = `applicant/create_form/`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                fields: JSON.stringify(
                [
                        'status',
                        'xtype',
                        'instructor',
                        'archived',
                    ]
                )
            }
        );
        let filterFields = response.data
        filterFields = deleteArrayItemByKeyValue(
            filterFields,
            'name',
            'submitButton'
        );
        this.setState(
            {
                filterFields: filterFields,
            }
        );
    }

    async filterCallBack(filters){
        filters = objectFilter(
            filters,
            (e) => (e !== '' || !!e)
        )
        await this.setState({
            filters: filters
        });
        await this.retrieveApplicants();
    }

    async retrieveApplicants() {
        const url = 'applicant/';
        const api = new BaseApi();
        let params = {
        };
        params = {...params, ...this.state.filters};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                applicants: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.applicants) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Соискатели'}
                    url={'hr/applicant'}
                    extraComponents={[
                        {
                            component: ApplicantCreateModal,
                            componentProps: {
                                callBack: this.retrieveApplicants.bind(this)
                            }
                        },
                        {
                            component: ApplicantUploadModal,
                            componentProps: {
                            },
                            callBack: this.retrieveApplicants.bind(this),
                        }
                    ]}
                    callBack={this.retrieveApplicants.bind(this)}
                    filterFields={this.state.filterFields?this.state.filterFields:[]}
                    filterCallBack={this.filterCallBack.bind(this)}
                    data={this.state.applicants}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    fields={[
                        {
                            title: 'ФИО',
                            name: ['last_name', 'first_name', 'patronymic'],
                            visible: true,
                            linkPattern: '/hr/applicant/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_blank',
                        },
                        {
                            title: 'Тип',
                            name: 'xtype_human',
                            visible: true,
                            chip: true,
                            color_rule: () => ('primary'),
                        },
                        {
                            title: 'Статус',
                            name: 'status.title',
                            visible: true,
                            chip: true,
                            color_rule: (value) => (value),
                            color_value: 'status.color',
                        },
                        {
                            title: 'Архив',
                            name: 'archived',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(ApplicantList)
